import React, { Component } from "react";
import { withRouter } from "react-router-dom";

//Styles
import "../../../../assets/css/guia_pages.css";

//Script
import "../../../../assets/js/home.js";

import { connect } from "react-redux";

import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";

//Styles
import "../../../../assets/css/guia_pages.css";
import CreateCursoSection from "./CreateCursoSection";

class CreateCurso extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allowed: false,
    };
  }

  componentWillMount() {
    const isAdmin = localStorage.getItem("_IS_ADM");
    if (!isAdmin) {
      window.location.href = "/";
      return;
    }
    this.setState({ allowed: true });
  }

  render() {
    return (
      this.state.allowed && (
        <div style={{width: "100vw", paddingLeft:"250px"}}>
          <AdminMenu />
          <CreateCursoSection history={this.props.history} />
        </div>
      )
    );
  }
}

const mapStateToProps = (store) => ({ view_by_tab: store.home.aba });
export default connect(mapStateToProps)(withRouter(CreateCurso));
